








import CategoryCardGrid from "~/themes/fiskarsMoominDefault/components/components/organisms/CategoryCardGrid/CategoryCardGrid.vue";
import { PropType } from "vue";
import { CategoryCardsInterface } from "types/index";
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "MoominCategoryCardGrid",
  components: { CategoryCardGrid },
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    items: {
      type: Array as PropType<CategoryCardsInterface[]>,
      default: () => [{}],
    },
  },
});
